/*****************************************
 * Component -  competition component
 * Created By - Ajay Chavan
 * Updated By - Ajay Chavan
 * Updated On - 22/09/2019
 *****************************************/
import { Component, OnInit, Input, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { Images } from '../../config/images-config';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../cep/store/index';
import { LocalStorageService } from '../../services/localstorage.service';
import { EncrDecrService } from '../../services/encr-decr.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { ObjectInterface } from '../../models/global-interface';
import { ReportAbusePopupComponent } from '../report-abuse-popup/report-abuse-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { ApiCallService } from 'src/app/shared/services/dynamic-api-calling.service';
import { Router } from '@angular/router';
import { LoginpopupComponent } from 'src/app/cep/dashboard-management/e-services/loginpopup/loginpopup.component';
import { ClipboardService } from '../../services/clipboard.service';
import { ToastrService } from 'ngx-toastr';
import { DynamicLinksService } from '../../services/dynamic-links';
import { environment } from 'src/environments/environment';
import { screenName, clickedOn } from 'src/app/shared/config/google-analytics-constants';
import { NgStyle, NgClass, NgIf, UpperCasePipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatCardImage } from '@angular/material/card';

@Component({
    selector: 'app-card-competition',
    templateUrl: './card-competition.component.html',
    styleUrls: ['./card-competition.component.scss'],
    standalone: true,
    imports: [MatCardImage, MatTooltip, NgStyle, NgClass, NgIf, UpperCasePipe]
})
export class CardCompetitionComponent implements OnInit, AfterContentChecked {
	image = Images;
	@Input() competitionData: any;
	competitionDate;
	selectedLanguage: string;
	landingLables: ObjectInterface;
	postDate: string;
	favorite: string;
	apiDetails: ObjectInterface;
	feedsDate: Date;
	todaysDate: Date;
	dateDiff: number;
	userId: any;
	token: string;
	timelineId: any;
	competitionStartDate: string;
	competitionEndtDate: string;
	competition: number;
	shareUrl: any;
	isBlind;
	favbool:boolean;
	constructor(
		private ref: ChangeDetectorRef,
		private dialog: MatDialog,
		private store: Store<fromStore.CEPState>,
		private localStorageService: LocalStorageService,
		private encrDecr: EncrDecrService,
		private apiCallService: ApiCallService,
		private router: Router,
		private clipboardService: ClipboardService,
		private toast: ToastrService,
		private dynamicLink: DynamicLinksService,
		private googleAnalyticsService: GoogleAnalyticsService) { }

	ngOnInit() {

		
		this.store.select(fromStore.getToken)
			.subscribe((token) => {
				this.token = token;
				if (this.token) {
					this.userId = this.encrDecr.get(this.localStorageService.getUserId());
				} else {
					this.userId = null;
				}
			});

			if (this.competitionData) {
				if (this.competitionData.fav.filter( (item) => item === this.userId ).length > 0) {
					this.favorite = 'favorite';
					this.favbool = true;
					//this.googleAnalyticsService.eventEmitter('Dashboard', 'click Favourite button of event', 'Click Event', 1);
				} else {
					this.favorite = 'favorite_border';
					this.favbool = false;
				}
			}

		this.store.select(fromStore.getSelectedLanguage)
			.subscribe((language) => {
				this.selectedLanguage = language;
				this.store.select(fromStore.getFeedsLabels)
					.subscribe((labels) => {
						this.landingLables = labels;
					});

			});

		this.store.select(fromStore.getApiCallingList)
			.subscribe((apiDetails) => {
				this.apiDetails = apiDetails;
				if (Object.keys(this.apiDetails).length > 0) {
					this.shareUrl = this.apiDetails['shareUrl'];
				}
			});
	}


/**
	 * Created by Vinita Sharma
	 * For text to speech functionality
	 */	
	speakText(textToSpeak){
		this.isBlind = this.localStorageService.getIsBlind();
		if(this.isBlind == 'true'){
		let speech = new SpeechSynthesisUtterance();
		speech.lang = "hi-IN";
		speech.text = textToSpeak;
		speech.volume = 1;
		speech.rate = 1;
		speech.pitch = 1;                    
		speechSynthesis.speak(speech);
		}
	  }

	  /**
	 * Created by Vinita Sharma
	 * Stops speaking when mouse leave the text content
	 */	
	  stopSpeaking(){
		speechSynthesis.cancel();
	  }

	  onClick() {
		this.googleAnalyticsService.eventEmitter(screenName.FEEDS, {
			log: clickedOn.VIEW,
			screenName: screenName.FEEDS + "_SCREEN",
			SECTION: screenName.COMPETITION_CARD ,
			clickedOn: clickedOn.BUTTON,
			title: clickedOn.VIEW,
			time: new Date(),
			isInput: false,
			contentId:this.competitionData.timelineId
		  })
		// let user = this.localStorageService.getItem("userId")
		// if (user === null) {
		// 	this.store.dispatch( new fromStore.GotoPageOnLogin('/cep/feeds') )
		// 	const dialogRef = this.dialog.open(LoginpopupComponent);
		// 	// this.router.navigate(["/Login/login"])
		// } else {

			this.router.navigate(['/cep/feeds/competition/', this.competitionData.timelineId])
		// }
	}
	
	/**
	 * Created by Akanksha J
	 * for reporting competition as abuse
	 */
	REPORT_ABUSE() {
		this.dialog.open(ReportAbusePopupComponent, {
			data: {
				userId: this.userId,
				timelineId: this.competitionData.timelineId,
				engagementType: 'competition',
				engagementId: this.competitionData.engagementId
			},
			maxHeight: '100vh',
			maxWidth: '100vw',
			disableClose: false
		});
	}

	/**
	 * Craeted by Ajay C
	 * For unmarking the favourites
	 */
	unMarkFavorite() {
		if (this.favbool) {
			this.competitionData = Object.assign({}, this.competitionData, { favourite: false });
			this.favorite = 'favorite_border';
			this.favbool = false;
			this.googleAnalyticsService.eventEmitter(screenName.FEEDS, {
				log: clickedOn.UNLIKE,
				screenName: screenName.FEEDS + "_SCREEN",
				SECTION: screenName.COMPETITION_CARD ,
				clickedOn: clickedOn.BUTTON,
				title: clickedOn.UNLIKE,
				time: new Date(),
				isInput: false,
				contentId:this.competitionData.timelineId
			  })
			//this.googleAnalyticsService.eventEmitter('Dashboard', 'click Favourite button of event', 'Click Event', 1);
		} else {
			this.competitionData = Object.assign({}, this.competitionData, { favourite: true });
			this.favorite = 'favorite';
			this.favbool = true;
			this.googleAnalyticsService.eventEmitter(screenName.FEEDS, {
				log: clickedOn.LIKE,
				screenName: screenName.FEEDS + "_SCREEN",
				SECTION: screenName.COMPETITION_CARD ,
				clickedOn: clickedOn.BUTTON,
				title: clickedOn.LIKE,
				time: new Date(),
				isInput: false,
				contentId:this.competitionData.timelineId
			  })
		}
		if (Object.keys(this.apiDetails).length > 0) {
			this.shareUrl = this.apiDetails['shareUrl'];
			if (this.userId) {
				this.store.dispatch(new fromStore.MarkFavorite({
					url: this.apiDetails['user'].base_url +
						this.apiDetails['user'].addToFavourite.url,
					method: this.apiDetails['user'].addToFavourite.method,
					body: {
						userId: this.userId,
						engagementId: this.competitionData.engagementId,
						engagementType: 'competition'
					}
				}));
			}
		}
	}

	ngAfterContentChecked() {
		this.ref.detectChanges();
		this.competitionStartDate = new Date(this.competitionData.startDate).toDateString();
		this.competitionEndtDate = new Date(this.competitionData.endDate).toDateString();
		this.postDate = new Date(this.competitionData.updatedAt).toDateString();
	}

	/**
	 * Created by Vinita Sharma'
	 * For generating dynamic link to share and redirect to new page to share post
	 */
	generateShareLink(media) {
		var url = this.shareUrl + '/cep/feeds/competition/' + this.competitionData.timelineId
		var metaTag  = {
			socialTitle: this.competitionData.en.heading,
			socialImageLink: this.competitionData.image[0]
		}
		this.apiCallService.configFirebaseLink(url, metaTag, media)
	}


	onCardClick() {
		//this.googleAnalyticsService.eventEmitter('search', 'user click on compitition', 'Click Event', 1);
	}

	async clickOnShare() {
		// //this.googleAnalyticsService.eventEmitter('Dashboard', 'User click share button of blog', 'Click Event', 1);
		this.googleAnalyticsService.eventEmitter(screenName.FEEDS, {
			log: clickedOn.SHARE,
			screenName: screenName.FEEDS + "_SCREEN",
			SECTION: screenName.COMPETITION_CARD ,
			clickedOn: clickedOn.BUTTON,
			title: clickedOn.SHARE,
			time: new Date(),
			isInput: false,
			contentId:this.competitionData.timelineId
		  })
		let url = environment.shareurl + '/cep/feeds/competition/' + this.competitionData.timelineId
		const shareUrl = await this.dynamicLink.generateDynamicLink(url)

		const success = this.clipboardService.copyTextToClipboard(shareUrl)
		if (success) {
			this.toast.success("Link Copied to Clipboard")
		}else{
			this.toast.error("Unable to copy Link")
		}

	}
}
